<section class="mh-experince image-bg featured-img-one" id="rdm-experience">
    <div class="img-color-overlay">
        <div class="container">
            <div class="row section-separator">
                <div class="col-sm-12 col-md-6">
                    <div class="mh-education">
                        <h3 class="wow fadeInUp" data-wow-duration="0.8s"
                            data-wow-delay="0.2s">Educação</h3>
                        <div class="mh-education-deatils">
                            <!-- Education Institutes-->
                            <div class="mh-education-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.3s">
                                <h4>Artificial Intelligence and Machine Learning
                                    <a href="">FIAP</a></h4>
                                <div class="mh-eduyear">2019-2020</div>
                                <p>Pós-graduação com ênfase no desenvolvimento
                                    de algoritmos de Inteligência Artifical,
                                    Machine Learning e Deep Learning.</p>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-education-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.3s">
                                <h4>Computação Natural <a href="">PUC-SP</a></h4>
                                <div class="mh-eduyear">2017-2017</div>
                                <p>Curso de extensão com ênfase em
                                    desenvolvimento de Algoritmos Genéticos e de
                                    Inteligência Artificial.</p>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-education-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.6s">
                                <h4>Análise e desenvolvimento de Sistemas <a
                                        href="">FATEC-SP</a></h4>
                                <div class="mh-eduyear">2012-2015</div>
                                <p>Faculdade de Análise e Desenvolvimento de
                                    Sistemas com ênfase em programação e padrões
                                    de desenvolvimento de sistemas
                                    computacionais.</p>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-education-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.5s">
                                <h4>Técnico em Informática <a href="">ETEC-SP</a></h4>
                                <div class="mh-eduyear">2009-2010</div>
                                <p>Curso técnico de informática com ênfase no
                                    desenvolvimento e arquitetura de sistemas
                                    computacionais.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="mh-work">
                        <h3>Experiência Profissional</h3>
                        <div class="mh-experience-deatils">
                            <!-- Education Institutes-->
                            <div class="mh-work-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.2s">
                                <h4>Senior Software & Gen AI Engineer <a href="">IBM</a></h4>
                                <div class="mh-eduyear">2024-atual</div>
                                <span>Responsabilidades :</span>
                                <ul class="work-responsibility">
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        de soluções de software de alta
                                        performance, aplicando boas práticas de
                                        arquitetura e engenharia de software</li>
                                    <li><i class="fa fa-circle"></i>Atuação
                                        estratégica no design e implementação de
                                        produtos, garantindo escalabilidade,
                                        segurança e eficiência</li>
                                    <li><i class="fa fa-circle"></i>Análise de
                                        dados, da coleta e tratamento até a
                                        extração de insights acionáveis</li>
                                    <li><i class="fa fa-circle"></i>Utilização do
                                        Watsonx para aplicar técnicas de
                                        Generative AI em soluções corporativas</li>
                                </ul>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-work-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.3s">
                                <h4>Senior Software Engineer & Tech Leader <a href="">IBM</a></h4>
                                <div class="mh-eduyear">2020-2024</div>
                                <span>Responsabilidades :</span>
                                <ul class="work-responsibility">
                                    <li><i class="fa fa-circle"></i>Liderança
                                        técnica de equipe de desenvolvimento de
                                        soluções cognitivas</li>
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        de aplicações usando as APIs da
                                        plataforma cognitiva Watson</li>
                                </ul>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-work-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.4s">
                                <h4>Senior Software Engineer <a href="">IBM</a></h4>
                                <div class="mh-eduyear">2017-2020</div>
                                <span>Responsabilidades :</span>
                                <ul class="work-responsibility">
                                    <li><i class="fa fa-circle"></i>Watson
                                        Assistant</li>
                                    <li><i class="fa fa-circle"></i>Watson
                                        Discovery</li>
                                    <li><i class="fa fa-circle"></i>Watson Text
                                        to Speech</li>
                                    <li><i class="fa fa-circle"></i>Watson
                                        Visual Recognition</li>
                                    <li><i class="fa fa-circle"></i>Watson
                                        Natural Language Classifier</li>
                                    <li><i class="fa fa-circle"></i>Watson
                                        Natural Language Understanding</li>
                                    <li><i class="fa fa-circle"></i>Watson
                                        Knowledge Studio</li>
                                </ul>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-work-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.5s">
                                <h4>.NET Developer <a href="">IBM</a></h4>
                                <div class="mh-eduyear">2014-2017</div>
                                <span>Responsabilidades :</span>
                                <ul class="work-responsibility">
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        de softwares para a área de Portabilidade
                                        de seguradoras</li>
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        e compartilhamento de regras de negócio
                                        para controle de pagamento</li>
                                    <li><i class="fa fa-circle"></i>Utilização de
                                        ORMs como Entity Framework Code First e
                                        NHibernate</li>
                                    <li><i class="fa fa-circle"></i>Criação de
                                        sistemas web utilizando Asp.Net MVC</li>
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        de serviços utilizando WCF com protocolo
                                        Rest</li>
                                </ul>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-work-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.6s">
                                <h4>Desenvolvedor .NET <a href="">PR Sistemas</a></h4>
                                <div class="mh-eduyear">2012-2014</div>
                                <span>Responsabilidades :</span>
                                <ul class="work-responsibility">
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        de softwares para gerenciamento de
                                        prontuário eletrônico do paciente</li>
                                    <li><i class="fa fa-circle"></i>Definição de
                                        arquitetura utilizando padrões de
                                        projetos de acordo com a necessidade do
                                        negócio</li>
                                    <li><i class="fa fa-circle"></i>Criação de
                                        interfaces gráficas projetadas sempre
                                        utilizando conceitos de usabilidade</li>
                                    <li><i class="fa fa-circle"></i>Melhorias em
                                        processos e otimização de software
                                        legado</li>
                                    <li><i class="fa fa-circle"></i>Participação
                                        em projeto para gestão da área de
                                        Qualidade de hospitais</li>
                                    <li><i class="fa fa-circle"></i>Criação de
                                        software para gerenciamento do processo
                                        para área de Enfermagem</li>
                                    <li><i class="fa fa-circle"></i>Utilização
                                        de tecnologias como Asp.Net Web Forms,
                                        Asp.Net MVC</li>
                                    <li><i class="fa fa-circle"></i>Criação de
                                        projetos utilizando Entity Framework</li>
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        em HTML 5, CSS 3 e Javascript. Sempre
                                        utilizando o conceito de separação de
                                        responsabilidade</li>
                                    <li><i class="fa fa-circle"></i>Utilização
                                        de padrões de projetos em Javascript</li>
                                </ul>
                            </div>
                            <!-- Education Institutes-->
                            <div class="mh-work-item dark-bg wow fadeInUp"
                                data-wow-duration="0.8s" data-wow-delay="0.7s">
                                <h4>Estágio Desenvolvedor .NET <a href="">2Soft
                                        Design e Sistemas</a></h4>
                                <div class="mh-eduyear">2011-2012</div>
                                <span>Responsabilidades :</span>
                                <ul class="work-responsibility">
                                    <li><i class="fa fa-circle"></i>Criação de
                                        novos
                                        softwares para clientes de diversos
                                        setores</li>
                                    <li><i class="fa fa-circle"></i>Participação
                                        em
                                        projeto para desenvolvimento de um
                                        ERP</li>
                                    <li><i class="fa fa-circle"></i>Desenvolvimento
                                        de novos softwares baseado em um
                                        framework proprietário</li>
                                    <li><i class="fa fa-circle"></i>Modelagem de
                                        classes</li>
                                    <li><i class="fa fa-circle"></i>Utilização
                                        de
                                        tecnologias como Windows Forms,
                                        Asp.Net WebForms e Entity Framework</li>
                                    <li><i class="fa fa-circle"></i>Criação de
                                        projetos para clínicas dentárias,
                                        empresas de tradução e entre outros
                                        projetos de gerenciamento
                                        administrativo</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>